import { apiFetch as apiFetchCF } from '../utils/api-fetch';

export default async function () {
  // eslint-disable-next-line no-undef
  const wpcf = wpcf7;

  document.querySelectorAll(
    '.wpcf7 > form',
  ).forEach((form) => {
    wpcf.init(form);
    form.closest('.wpcf7').classList.replace('no-js', 'js');
  });

  // eslint-disable-next-line no-restricted-syntax
  for (const formId of wpcf.schemas.keys()) {
    apiFetchCF({
      endpoint: `contact-forms/${formId}/feedback/schema`,
      method: 'GET',
    }).then((response) => {
      wpcf.schemas.set(formId, response);
    });
  }
}
